import React, { forwardRef } from 'react';
import '../common.scss';
import './styles.scss';
import clsx from 'clsx';
import { useCustomComponent } from '@/hooks';

export interface TextareaProps {
  id?: string;
  name: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  value?: string;
  rows?: number;
  cols?: number;
  maxLength?: number;
  size?: 'default' | 'large';
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  className?: string;
  'aria-label'?: string;
  'aria-describedby'?: string;
}

const BaseTextarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      id,
      name,
      placeholder = '',
      required = false,
      disabled = false,
      value = '',
      rows = 4,
      cols,
      maxLength,
      size = 'default',
      onChange,
      onBlur,
      onFocus,
      onKeyDown,
      className = '',
      ...ariaProps
    },
    ref
  ) => {
    return (
      <textarea
        ref={ref}
        id={id}
        name={name}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        value={value}
        rows={rows}
        cols={cols}
        maxLength={maxLength}
        autoComplete="off"
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        className={clsx(
          'peptalk-form-element peptalk-textarea',
          `peptalk-textarea-${size}`,
          className
        )}
        {...ariaProps}
      />
    );
  }
);

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (props, ref) => {
    const Component = useCustomComponent({
      componentName: 'Textarea',
      Component: BaseTextarea,
    });
    return <Component {...props} ref={ref} />;
  }
);

Textarea.displayName = 'Textarea';
